import React from 'react';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import { CloseButton, TextV2, ButtonV2, Flex } from '@withjoy/joykit';

import { useDashboardTelemetry } from '../../../Dashboard.telemetry';

export interface ShippingAddressReminderBannerProps {
  isAddressReminderVisible: boolean;
  handleDismissAddressReminderClick: (e: React.MouseEvent) => void;
  handleAddShippingAddress: () => void;
}

export const ShippingAddressReminderBanner: React.FC<ShippingAddressReminderBannerProps> = ({
  isAddressReminderVisible,
  handleDismissAddressReminderClick,
  handleAddShippingAddress
}) => {
  const { addShippingAddressButtonBannerClicked } = useDashboardTelemetry();
  const { t2 } = useTranslation('adminDashboardV2');
  const { description, buttonLabel } = t2('addressReminderBanner');

  const handleCTAClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleAddShippingAddress();
    addShippingAddressButtonBannerClicked();
  };

  return (
    <Flex
      display={isAddressReminderVisible ? 'flex' : 'none'}
      visibility={isAddressReminderVisible ? 'visible' : 'hidden'}
      position="relative"
      zIndex={3}
      top={0}
      width="100%"
      backgroundColor="brandPurple5"
      minHeight={{ _: pxToRem(136), xs: pxToRem(64) }}
      paddingX={5}
      paddingY={{ _: 5, xs: 4 }}
      justifyContent="space-between"
      alignItems={{ _: 'flex-start', xs: 'center' }}
      alignSelf="stretch"
    >
      <Flex display={{ _: 'none', xs: 'flex' }} />
      <Flex flexDirection={{ _: 'column', xs: 'row' }}>
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          textAlign="left"
          paddingBottom={{ _: 4, xs: 0 }}
          paddingRight={{ xs: 6 }}
          color="white"
          maxWidth={{ _: pxToRem(260), xs: '100%' }}
        >
          <TextV2 typographyVariant="hed2">{description}</TextV2>
        </Flex>
        <Flex flexDirection="column" justifyContent="center" alignItems="flex-start" textAlign="left">
          <ButtonV2
            onClick={handleCTAClick}
            color={'white'}
            borderColor={'white'}
            border="2px solid transparent"
            background={'transparent'}
            borderRadius="20px"
            fontSize="16px"
            fontWeight="semibold"
            _hover={{ border: '2px solid white', background: '#502080', color: 'white' }}
            _active={{
              border: '2px solid white',
              background: '#502080',
              borderColor: 'white',
              color: 'white'
            }}
            variant={'outline'}
            size={'md'}
          >
            {buttonLabel}
          </ButtonV2>
        </Flex>
      </Flex>
      <Flex flexDirection={{ _: 'column', xs: 'row' }} alignItems="center" paddingLeft={6}>
        <CloseButton
          height={7}
          minWidth={7}
          paddingRight={0}
          paddingLeft={0}
          borderRadius={'100%'}
          color={'white'}
          alignItems={'center'}
          _hover={{ background: '#502080', color: 'white' }}
          _active={{ background: '#502080', color: 'white' }}
          onClick={(e: React.MouseEvent) => handleDismissAddressReminderClick(e)}
        />
      </Flex>
    </Flex>
  );
};
